import { GET_REGIONS } from '../actions/types';

const initialState = {
  list: []
};
// const initialState = [{ id: 1, name: 'Львівська' }, { id: 2, name: 'Київська' }];

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_REGIONS: {
      return { ...state, ...{ list: action.regionsData } };
    }
    default:
      return state;
  }
}
